// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let listeners = {
  contents: []
};

function addListener(listener) {
  listeners.contents.push(listener);
  return () => {
    listeners.contents = listeners.contents.filter(l => l !== listener);
  };
}

function didLogin() {
  listeners.contents.forEach(listener => listener());
}

exports.addListener = addListener;
exports.didLogin = didLogin;
/* No side effect */
